export default __webpack_public_path__ + "static/media/complementary--trailers--g3.e99a3109.png";